import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import analyticsService, { AMPLITUDE_EXPERIMENTS } from 'services/AnalyticsService';

import { RootState } from 'store/types';
import * as routerSelectors from 'store/router/selectors';
import * as bookingTypes from 'store/booking/types';
import * as bookingActions from 'store/booking/actions';
import * as bookingSelectors from 'store/booking/selectors';
import * as geoLocationSelectors from 'store/geolocation/selectors';
import * as myDoctorsSelectors from 'store/myDoctors/selectors';
import * as findProviderActions from 'store/findProvider/actions';
import { ProviderSummary } from 'store/findProvider/types';
import { getMyDoctors } from 'shared/src/store/myDoctors/actions';
import BookingSpecialtyOrMyDoctorSelectDefault from './default';
import BookingSpecialtyOrMyDoctorSelectNPV from './npv';

export interface Props extends RouteComponentProps {
  appointmentDetails: bookingTypes.AppointmentDetails;
  doctorsLoading: boolean;
  doctors: ProviderSummary[];
  geolocation: Coordinates;
  geolocationStatus: boolean;
  getSpecialties: typeof bookingActions.getSpecialties;
  getMyDoctors: typeof getMyDoctors;
  setActiveProviderSearchFilter: typeof findProviderActions.setActiveProviderSearchFilter;
  setDoctor: typeof bookingActions.setDoctor;
  setSpecialty: typeof bookingActions.setSpecialty;
  specialties: bookingTypes.Specialty[];
  specialtiesLoading: boolean;
  setSort: typeof findProviderActions.setSortBy;
  providerSearch: typeof findProviderActions.schedulingProviderSearch;
  currentRouteName?: string;
  previousRouteName?: string;
}

export function BookingSpecialtyOrMyDoctorSelect(props: Props) {
  const [showStandardDesign, setShowStandardDesign] = useState(true);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const result = analyticsService.fetchExperimentVariant(
      AMPLITUDE_EXPERIMENTS.SCHEDULING_NPV_PHASE_1.flagKey
    );
    setIsLoading(false);
    setShowStandardDesign(result?.value === AMPLITUDE_EXPERIMENTS.SCHEDULING_NPV_PHASE_1.variantA);
  }, []);

  if (isLoading) return null;

  return (
    <>
      {showStandardDesign ? (
        <BookingSpecialtyOrMyDoctorSelectDefault {...props} />
      ) : (
        <BookingSpecialtyOrMyDoctorSelectNPV {...props} />
      )}
    </>
  );
}

const mapStateToProps = (state: RootState) => ({
  appointmentDetails: bookingSelectors.appointmentDetailsSelector(state),
  doctorsLoading: myDoctorsSelectors.myDoctorFetchingSelector(state),
  doctors: bookingSelectors.currentPatientBookingDoctorsSelector(state),
  geolocationStatus: geoLocationSelectors.geolocationAcceptedSelector(state),
  specialties: bookingSelectors.getSpecialtiesSortedByName(state),
  specialtiesLoading: bookingSelectors.specialtiesFetchingSelector(state),
  currentRouteName: routerSelectors.currentLocationPathNameSelector(state),
  previousRouteName: routerSelectors.previousLocationPathNameSelector(state)
});

const mapDispatchToProps = {
  getMyDoctors,
  getSpecialties: bookingActions.getSpecialties,
  setActiveProviderSearchFilter: findProviderActions.setActiveProviderSearchFilter,
  setDoctor: bookingActions.setDoctor,
  setSpecialty: bookingActions.setSpecialty,
  setSort: findProviderActions.setSortBy,
  providerSearch: findProviderActions.schedulingProviderSearch
};

export default connect(mapStateToProps, mapDispatchToProps)(BookingSpecialtyOrMyDoctorSelect);
